<template>
    <div class="d-flex">
        <v-icon
            class="mx-2"
            :disabled="dissabled"
            @click="clipboardItemUp"
        >
            expand_less
        </v-icon>
        <v-icon
            class="mx-2"
            :disabled="dissabled"
            @click="clipboardItemDown"
        >
            expand_more
        </v-icon>
        <v-icon
            class="mx-2"
            :disabled="dissabled"
            @click="clipboardItemTop"
        >
            keyboard_double_arrow_up
        </v-icon>
        <v-icon
            class="mx-2"
            :disabled="dissabled"
            @click="clipboardItemBottom"
        >
            keyboard_double_arrow_down
        </v-icon>
    </div>
</template>
<script>
import { guidEqual } from '@/utils/guid.js';

export default {
    props: {
        tickets: {
            type: Array,
            required: true,
        },
        selected: {
            type: Array,
            required: true,
        },
    },
    computed: {
        dissabled() {
            return this.selected.length === 0;
        }
    },
    methods: {
        moveArrayItem (targetArray, indexFrom, indexTo) { 
            let targetElement = targetArray[indexFrom]; 
            let increment = (indexTo - indexFrom) / Math.abs (indexTo - indexFrom); 

            for (let Element = indexFrom; Element != indexTo; Element += increment){ 
                targetArray[Element] = targetArray[Element + increment]; 
            } 
            targetArray[indexTo] = targetElement; 
        },
        changeClipboardItemPosition(newPosition) {
            let newTickets = [...this.tickets];
            let changed = false;
            let selected = this.selected;
            let lastIndex = newTickets.length-1;
            let selectedCount = selected.length;
            let indexFrom = 0;
            let foundCount = 0;
            // need to move selected tickets based on the order inwhich they occur in newTickets
            // If moving down start with latst item and iterate backwards else start at position zero and iterate forwards
            for(indexFrom = newPosition === 1 ? lastIndex : 0; indexFrom > -1 && indexFrom < newTickets.length; indexFrom -= newPosition) {
                let ticket = newTickets[indexFrom];
                if(selected.find(selectedTicket => guidEqual(selectedTicket.TR_rowid, ticket.TR_rowid))) {
                    ++foundCount;
                    if((newPosition === -1 && indexFrom > 0) 
                    || (newPosition ===  1 && indexFrom < lastIndex)) {
                        this.moveArrayItem(newTickets, indexFrom, indexFrom+newPosition);
                        changed = true;
                    }
                }
                if(foundCount === selectedCount) {
                    break;
                }
            }
            // Only post to server if something actually changed.
            if(changed) {
                this.$emit('move-clipboard-items', newTickets);
            }
        },
        clipboardItemUp() {
            this.changeClipboardItemPosition(-1);
        },
        clipboardItemDown() {
            this.changeClipboardItemPosition(1);
        },
        clipboardItemTop() {
            let newTickets = [];
            for(let ticket of this.tickets) {
                if(this.selected.find(selectedTicket => guidEqual(selectedTicket.TR_rowid, ticket.TR_rowid))) {
                    newTickets.push(ticket);
                }
            }
            for(let ticket of this.tickets) {
                if(!this.selected.find(selectedTicket => guidEqual(selectedTicket.TR_rowid,  ticket.TR_rowid))) {
                    newTickets.push(ticket);
                }
            }
            this.$emit('move-clipboard-items', newTickets);
        },
        clipboardItemBottom() {
            let newTickets = [];
            for(let ticket of this.tickets) {
                if(!this.selected.find(selectedTicket => guidEqual(selectedTicket.TR_rowid, ticket.TR_rowid))) {
                    newTickets.push(ticket);
                }
            }
            for(let ticket of this.tickets) {
                if(this.selected.find(selectedTicket => guidEqual(selectedTicket.TR_rowid,  ticket.TR_rowid))) {
                    newTickets.push(ticket);
                }
            }
            this.$emit('move-clipboard-items', newTickets);
        },        
    }    
};
</script>